import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DrawerMenu.css';
import {useAppState} from "../../store/useAppState";

interface DrawerMenuProps {
    isOpen: boolean;
    onClose: () => void;
}

const DrawerMenu: React.FC<DrawerMenuProps> = ({ isOpen, onClose }) => {
    const { t } = useTranslation();
    const { isDrawerMenuOpen, changeDrawerMenuState } = useAppState();
    
    const menuItems = [
        { path: '/terms', label: t('drawerMenu.termsAndConditions') },
        { path: '/privacy', label: t('drawerMenu.privacyPolicy') },
        { path: '/subscription-terms', label: t('drawerMenu.subscriptionTerms') },
        { path: '/support', label: t('drawerMenu.supportCenter') },
    ];
    return (
        <div className={`drawer-menu ${isDrawerMenuOpen ? 'drawer-menu--open' : ''}`}>
            <div className="drawer-menu__overlay" onClick={() => {
                changeDrawerMenuState(false)
            }} />
            <div className="drawer-menu__content">
                <div className="drawer-menu__header">
                    <img src={process.env.PUBLIC_URL + '/images/logo-full.png'} alt="aiCourses Logo" className="drawer-menu__logo" />
                    <button className="drawer-menu__close" onClick={() => {
                        changeDrawerMenuState(false)
                    }}>
                        ×
                    </button>
                </div>
                <div className="drawer-menu__header-separator" />
                <nav className="drawer-menu__nav">
                    {menuItems.map((item, idx) => (
                        <React.Fragment key={item.path}>
                            <Link
                                to={item.path}
                                className="drawer-menu__item"
                                onClick={() => {
                                    changeDrawerMenuState(false)
                                }}
                            >
                                {item.label}
                            </Link>
                            {idx < menuItems.length - 1 && <div className="drawer-menu__separator" />}
                        </React.Fragment>
                    ))}
                </nav>
            </div>
        </div>
    );
};

export default DrawerMenu;
